import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { FlourishEmbedEntry } from "frontend/contentful/schema/blocks";
import { FlourishEmbed } from "design-system/components/blocks/flourish-embed/flourish-embed";
import { createComponentHeaderProps } from "../primitives/component-header.props";

interface FlourishEmbedOptions {
  headerAbove?: boolean;
}

export const ContentfulFlourishEmbed = createContentfulComponent<
  FlourishEmbedEntry,
  FlourishEmbedOptions
>(({ entry, options }) => {
  if (!entry.fields.embedSourceUrl) {
    return null;
  }

  const headerAbove = options?.headerAbove || false;

  return (
    <FlourishEmbed
      headerContent={createComponentHeaderProps(entry.fields.header)}
      HeadingLevel={headerAbove ? "h3" : "h2"}
      align={entry.fields.alignment}
      embedSourceUrl={entry.fields.embedSourceUrl}
    />
  );
});
